<template>
  <v-container>
    <div style="background-color: rgb(230, 233, 242); padding-left: 20px; padding-bottom: 15px; padding-bottom: 15px;">
        <h2 style="font-size: 2.5rem; color: rgb(0, 30, 67)">¡Bienvenidos a IDmaderas!</h2>  
        <b style="color: rgb(0, 30, 67)">IDmaderas</b> es una herramienta técnica diseñada para facilitar la identificación de maderas a través de un proceso sencillo y dinámico. Proporcionamos 
          información sobre las características anatómicas necesarias para reconocer patrones en la estructura de la madera y compararlos con referencias.<br>

          Para ayudarte en este proceso, <b style="color: rgb(0, 30, 67)">IDmaderas</b> ofrece filtros de descarte que te permitirán identificar el nombre de la madera que observas. Además, fortalecemos los esfuerzos de regulación 
          y control de productos forestales en Perú, sirviendo también como fuente de consulta académica. <br><br>

          ¡Te invitamos a explorar cómo <b style="color: rgb(0, 30, 67)">IDmaderas</b> puede asistirte en la identificación de maderas!<br>
        
      </div><br>
      <div>
        <v-row class="mb-1 justify-center mb-n1">
          <v-col class="mb-1" md="2">            
            <v-card class="mx-auto card-hover" max-width="100%" theme="dark" style="border-top: 5px solid #009DDC; margin-top: 5px; text-align: center;">
              <router-link :to="{ name: 'lista' }" style="text-decoration: none;">
                <!-- Tooltip surrounding the image and text -->
                <v-tooltip bottom color="rgb(0, 124, 186)">
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <v-img class="align-end text-white" contain height="90" :src="require('../assets/home1.png')" style="margin-top: 5px; margin-bottom: 5px;"></v-img>
                      <b><p style="font-size: 1rem; color: rgb(15, 135, 201);">Especies</p></b>
                    </div>
                  </template>
                  <span style="font-size: 0.9rem; color: white;">Encuentra las fichas de las especies que contiene IDmaderas.</span>
                </v-tooltip>
              </router-link>
            </v-card>
          </v-col>
          <v-col class="mb-1" md="2"> 
            <v-card class="mx-auto card-hover" max-width="100%" theme="dark" style="border-top: 5px solid #009DDC; margin-top: 5px; text-align: center;">
              <router-link :to="{ name: 'especie' }" style="text-decoration: none;">
                <!-- Tooltip surrounding the image and text -->
                <v-tooltip bottom color="rgb(0, 124, 186)">
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <v-img class="align-end text-white" contain height="90" :src="require('../assets/home2.png')" style="margin-top: 5px; margin-bottom: 5px;"></v-img>
                      <b><p style="font-size: 1rem; color: rgb(15, 135, 201);">Buscador</p></b>
                    </div>
                  </template>
                  <span style="font-size: 0.9rem; color: white;">¿No sabes qué madera estás observando? Utiliza los filtros de IDmaderas y encuéntrala.</span>
                </v-tooltip>
              </router-link>
            </v-card>
          </v-col>  
          <v-col class="mb-1" md="2"> 
            <v-card class="mx-auto card-hover" max-width="100%" theme="dark" style="border-top: 5px solid #009DDC; margin-top: 5px; text-align: center;">
              <router-link :to="{ name: 'recursos' }" style="text-decoration: none;">
                <!-- Tooltip surrounding the image and text -->
                <v-tooltip bottom color="rgb(0, 124, 186)">
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <v-img class="align-end text-white" contain height="90" :src="require('../assets/home3.png')" style="margin-top: 5px; margin-bottom: 5px;"></v-img>
                      <b><p style="font-size: 1rem; color: rgb(15, 135, 201);">Recursos</p></b>
                    </div>
                  </template>
                  <span style="font-size: 0.9rem; color: white;">Te compartimos más referencias para que  complementes lo aprendido con IDmaderas.</span>
                </v-tooltip>
            </router-link>
            </v-card>
          </v-col> 
          <v-col class="mb-1" md="2"> 
            <v-card class="mx-auto card-hover" max-width="100%" theme="dark" style="border-top: 5px solid #009DDC; margin-top: 5px; text-align: center;">
              <router-link :to="{ name: 'glosario' }" style="text-decoration: none;">
                <!-- Tooltip surrounding the image and text -->
                <v-tooltip bottom color="rgb(0, 124, 186)">
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <v-img class="align-end text-white" contain height="90" :src="require('../assets/home6.png')" style="margin-top: 5px; margin-bottom: 5px;"></v-img>
                      <b><p style="font-size: 1rem; color: rgb(15, 135, 201);">Glosario</p></b>
                    </div>
                  </template>
                  <span style="font-size: 0.9rem; color: white;">Conceptos claves sobre las características anatómicas de la madera.</span>
                </v-tooltip>
            </router-link>
            </v-card>
          </v-col>
          <v-col class="mb-1" md="2"> 
            <v-card class="mx-auto card-hover" max-width="100%" theme="dark" style="border-top: 5px solid #009DDC; margin-top: 5px; text-align: center;">
              <router-link :to="{ name: 'contacto' }" style="text-decoration: none;">
                <v-tooltip bottom color="rgb(0, 124, 186)">
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <v-img class="align-end text-white" contain height="90" :src="require('../assets/home4.png')" style="margin-top: 5px; margin-bottom: 5px;"></v-img>
                      <b><p style="font-size: 1rem; color: rgb(15, 135, 201);">Contacto</p></b>
                    </div>
                  </template>
                  <span style="font-size: 0.9rem; color: white;">Si quieres saber más sobre IDmaderas, escríbenos.</span>
                </v-tooltip>
            </router-link>
            </v-card>
          </v-col>
          <v-col class="mb-1" md="2"> 
            <v-card class="mx-auto card-hover" max-width="100%" theme="dark" style="border-top: 5px solid #009DDC; margin-top: 5px; text-align: center;">
              <router-link :to="{ name: 'creditos' }" style="text-decoration: none;">
                <v-tooltip bottom color="rgb(0, 124, 186)">
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <v-img class="align-end text-white" contain height="90" :src="require('../assets/home7.png')" style="margin-top: 5px; margin-bottom: 5px;"></v-img>
                      <b><p style="font-size: 1rem; color: rgb(15, 135, 201);">Créditos</p></b>
                    </div>
                  </template>
                  <span style="font-size: 0.9rem; color: white;">Si quieres saber más sobre IDmaderas, escríbenos.</span>
                </v-tooltip>
            </router-link>
            </v-card>
          </v-col>
          <!-- <v-col class="mb-1" md="2" v-if="(rolOid === 1 || rolOid === 2)">
            <v-card class="mx-auto card-hover" max-width="100%" theme="dark" style="border-top: 5px solid #009DDC; margin-top: 5px; text-align: center;">
              <router-link :to="{ name: 'administracion' }" style="text-decoration: none;">
                <v-tooltip bottom color="rgb(0, 124, 186)">
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <v-img class="align-end text-white" contain height="90" :src="require('../assets/home5.png')" style="margin-top: 5px; margin-bottom: 5px;"></v-img>
                      <b><p style="font-size: 1rem; color: rgb(15, 135, 201);">Administración</p></b>
                    </div>
                  </template>
                  <span style="font-size: 0.9rem; color: white;">En este espacio actualizamos IDmaderas (solo para administradores).</span>
                </v-tooltip>
            </router-link>
            </v-card>
          </v-col>           -->
        </v-row>
      </div>
  </v-container>
</template>

<script>
  export default {
    name: 'HelloWorld',

    data: () => ({
      
    }),
    computed: {
      rolOid() {
      // Aquí obtén el nombre del usuario autenticado desde Vuex o desde el almacenamiento local
          const oid_rol = localStorage.getItem('rolu');
          return Number(oid_rol);
      },    
      userOid() {
        // Aquí obtén el nombre del usuario autenticado desde Vuex o desde el almacenamiento local
        const oid_usuario = localStorage.getItem('oidu');
        return oid_usuario;
      },
    },
  }
</script>
<style>
    p {
      font-family: 'Heebo', sans-serif !important;
        font-size: 17px;        
        line-height: 1.6em;
    }
    h1 {
      font-family: 'Heebo', sans-serif !important;
        font-size: 2.5rem;
    }
    h2 {
      font-family: 'Sofia Sans', sans-serif !important;
    }
    h3 {
      font-family: 'Sofia Sans', sans-serif !important;
    }
    h5 {
        font-family: 'Sofia Sans', sans-serif !important;
        font-size: 1.25rem;
    }
    .card-hover {
      transition: transform 0.3s ease, box-shadow 0.3s ease;
    }
    .card-hover:hover {
      transform: scale(1.05);
      box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
    }
</style>